/* NetworkDiscoveryEditor.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const _ = require("lodash");

class NetworkDiscoveryEditor extends GameEditor {
    constructor(
        logger,
        di,
        registeredDetails,
        editorState,
        editorLayoutMgr,
        editorLayout,
        userSession,
        editorTabCmpnt,
        solutionsManager,
        steveIo,
        NetworkDiscoveryPlan,
        DeviceEntity,
        WorkEntity
    ) {
        super(logger, di, editorState.editorState, editorLayoutMgr);

        this._logger = logger;
        this._registeredDetails = registeredDetails;
        this._editorLayout = editorLayout;
        this._tabCmpnt = editorTabCmpnt;
        this._editorTabState = editorState;
        this._steveIo = steveIo;
        this._userSession = userSession;
        this._deviceEntity = DeviceEntity;
        this._workEntity = WorkEntity;
        this._device = undefined;
        this._workLog = [];
        this._WorkFeed = undefined;
        this._networkDiscoveryId = undefined;

        this._runningStart = false;

        // Network DiscoveryPlan Entity Class
        this._networkDiscoveryPlan = NetworkDiscoveryPlan;
        this._networkDiscoveryPlanEntity = undefined;

        this._networkDiscoveryPlanFeed = undefined;
        this._currentDiscoveryWorkId = undefined;

        this._networkDiscoveryExecutionFeed = undefined;
        this._networkDiscoveryExecutionEntity = undefined;

        this._activeOrgId = userSession.activeOrganization.id;

        let solutionDefinition = solutionsManager.getActiveSolution();
        let networkDiscoveryEditorViews = _.get(
            solutionDefinition,
            "networkDiscoveryEditor.viewNamespaces",
            []
        );
        let networkDiscoveryEditorActions = _.get(
            solutionDefinition,
            "networkDiscoveryEditor.actionNamespaces",
            []
        );
        let launchOptions = editorState.launchOptions;
        this._selectedPlan = _.get(launchOptions, "planId", undefined);

        this.setNamespaceGlobs(
            networkDiscoveryEditorViews.concat(networkDiscoveryEditorActions),
            true
        );

        this._instanceEditorState = {};
        this._tabId = launchOptions.id || "Unknown";

        this.retardActions(true);

        this._networkDiscoverySettingsFeed = undefined;
        this._selectedNetworkDiscoverySetting = undefined;
        this._defaultNetworkDiscoverySettingEntity = undefined;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerPlanEntityListeners() {
        // this._networkDiscoveryPlanFeed.on("DirtyStateChanged", (this._onDirtyStateChanged = this._onDirtyStateChanged.bind(this)));
        this._networkDiscoveryPlanEntity.on(
            "EntityDeletedFromSystem",
            (this._onNetworkDiscoveryRemoved = this._onNetworkDiscoveryRemoved.bind(this))
        );
        this._networkDiscoveryPlanEntity.on(
            "NamePropertyUpdated",
            (this._onNamePropertyUpdated = this._onNamePropertyUpdated.bind(this))
        );
    }

    _unregisterPlanEntityListeners() {
        // this._networkDiscoveryPlanFeed.removeListener("DirtyStateChanged", this._onDirtyStateChanged);
        this._networkDiscoveryPlanEntity.removeListener(
            "EntityDeletedFromSystem",
            this._onNetworkDiscoveryRemoved
        );
        this._networkDiscoveryPlanEntity.removeListener(
            "NamePropertyUpdated",
            this._onNamePropertyUpdated
        );
    }

    _registerExecutionFeedListeners() {
        this._networkDiscoveryExecutionFeed.on(
            "EntityPropertiesUpdated",
            (this._onExecutionEntityPropertiesUpdated =
                this._onExecutionEntityPropertiesUpdated.bind(this))
        );
    }

    _registerWorkFeedListeners() {
        this._WorkFeed.on(
            "InstanceAdded",
            (this._onWorkEntityPropertiesUpdated = this._onWorkEntityPropertiesUpdated.bind(this))
        );
    }

    _unRegisterWorkFeedListeners() {
        this._WorkFeed.removeListener("InstanceAdded", this._onWorkEntityPropertiesUpdated);
    }

    _unregisterExecutionFeedListeners() {
        this._networkDiscoveryExecutionFeed.removeListener(
            "EntityPropertiesUpdated",
            this._onExecutionEntityPropertiesUpdated
        );
    }

    _onNetworkDiscoveryRemoved() {
        this.currentEntityRemoved = true;
        if (!this.currentEntityDeleteInProgress) {
            this.currentEntityRemoved = false;
            this.closeEditor(this.editorTabStateId, true);
        }
    }

    _onNamePropertyUpdated() {
        this.updateTab(this._networkDiscoveryPlanEntity.pristineProperties.name);
    }

    _onExecutionEntityPropertiesUpdated() {
        const executionFeedCache = Object.values(
            _.get(this._networkDiscoveryExecutionFeed, "cache", {})
        );
        if (executionFeedCache.length > 0) {
            this._networkDiscoveryExecutionEntity = executionFeedCache[0];
        }

        this.emit("NetworkExecutionFeedUpdated");
    }

    _onWorkEntityPropertiesUpdated(entity) {
        this._setWorkAndLogs(entity).then(() => {
            this._setWorkFeed();
        });
    }

    _registerLogFeedListeners() {
        this._unregisterLogFeedListeners();
        this._networkDiscoveryWorkFeed.on(
            "ElementInitialized",
            (this._onLogInitialized = this._onLogInitialized.bind(this))
        );
        this._networkDiscoveryWorkFeed.on(
            "ElementAdded",
            (this._onLogInitialized = this._onLogInitialized.bind(this))
        );
    }

    _unregisterLogFeedListeners() {
        if (this._networkDiscoveryWorkFeed) {
            this._networkDiscoveryWorkFeed.removeAllListeners("ElementInitialized");
            this._networkDiscoveryWorkFeed.removeAllListeners("ElementAdded");

            // this._networkDiscoveryWorkFeed.removeListener("EntityPropertiesUpdated", this._onWorkPristinePropertiesChanged);
        }
    }

    _registerDiscoverySettingsFeedListeners() {}
    _unregisterDiscoverySettingsFeedListeners() {}

    getTabCmpnt() {
        return this._tabCmpnt;
    }

    get activeOrgId() {
        return this._activeOrgId;
    }

    get editorTabStateId() {
        return this._editorTabState.id;
    }

    get networkDiscoveryPlanFeed() {
        return this._networkDiscoveryPlanFeed;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    retrieveNetworkDiscoveryPlan() {
        if (this._networkDiscoveryPlanFeed) {
            return Promise.resolve();
        }

        return this._networkDiscoveryPlan
            .retrieveNetworkDiscoveryPlan(this.activeOrgId)
            .then((networkDiscoveryPlanFeed) => {
                this._networkDiscoveryPlanFeed = networkDiscoveryPlanFeed;
                // this._registerPlanEntityListeners();
                return Promise.resolve();
            });
    }

    retrieveNetworkDiscoveryExecutionEntity(loadExecution = false, executionId = false) {
        if (loadExecution) {
            let query = {};
            if (executionId) {
                query = {id: executionId};
            }
            return this._networkDiscoveryPlanFeed
                .loadRelatedExecutions(query, {}, {createdOn: -1}) // Descending sort to get the latest date first
                .then((data) => {
                    // console.log(data);
                    this._networkDiscoveryExecutionEntity = data[0];
                    return Promise.resolve(data);
                })
                .then(() => {
                    return this.getWorkFeed(!!executionId);
                });
        }
        if (this._networkDiscoveryExecutionFeed) {
            return Promise.resolve();
        }

        this._networkDiscoveryExecutionFeed =
            this._networkDiscoveryPlanFeed.startRelatedExecutionsFeed({}, {}, {createdOn: -1}); // Descending sort to get the latest date first
        return this._networkDiscoveryExecutionFeed
            .whenInitialized()
            .then((networkDiscoveryExecutionFeed) => {
                this._networkDiscoveryExecutionFeed = networkDiscoveryExecutionFeed;

                this._registerExecutionFeedListeners();
                this._networkDiscoveryExecutionEntity = Object.values(
                    _.get(this._networkDiscoveryExecutionFeed, "cache", {})
                )[0];

                return Promise.resolve();
            })
            .then(() => {
                return this.getWorkFeed();
            });
    }
    // Setting workfeed and updating log

    _setWorkAndLogs(latestWork) {
        return Promise.resolve().then(() => {
            this._networkDiscoveryWork = latestWork;
            if (latestWork) {
                if (!latestWork.summary.endTime) {
                    if (latestWork.log) {
                        this.updateDiscoveryLog(latestWork.log, false);
                    }
                    this._currentDiscoveryWorkId = latestWork.id;
                } else if (
                    this._networkDiscoveryExecutionEntity.getStatus() !== "RUNNING" &&
                    !this._activeView._planRunning
                ) {
                    this._currentDiscoveryWorkId = undefined;

                    let logFeed = latestWork.startRelatedLogFeed();
                    logFeed.whenInitialized().then((log) => {
                        if (!_.isEmpty(log)) {
                            this.updateDiscoveryLog(
                                Object.values(log.getCache()).length > 0
                                    ? Object.values(log.getCache())[0].getLog()
                                    : [],
                                false
                            );
                        }
                    });
                }
            }
            return Promise.resolve();
        });
    }

    _setWorkFeed() {
        return Promise.resolve()
            .then(() => {
                if (this._currentDiscoveryWorkId) {
                    if (this._networkDiscoveryWorkFeed) {
                        const sourceDiscoveryWorkId = _.get(
                            this._networkDiscoveryWorkFeed,
                            "_initialRequest.payload.entityId"
                        );
                        if (this._currentDiscoveryWorkId !== sourceDiscoveryWorkId) {
                            /*
                            this._unregisterLogFeedListeners();
                            this._networkDiscoveryWorkFeed.shutdown().then(() => {
                                this._networkDiscoveryWorkFeed = this._workEntity.startWorkLogElementFeed(
                                    this.activeOrgId,
                                    this._currentDiscoveryWorkId
                                );
                            });
                            */
                            this._networkDiscoveryWorkFeed =
                                this._workEntity.startWorkLogElementFeed(
                                    this.activeOrgId,
                                    this._currentDiscoveryWorkId
                                );
                        }
                    } else {
                        this._networkDiscoveryWorkFeed = this._workEntity.startWorkLogElementFeed(
                            this.activeOrgId,
                            this._currentDiscoveryWorkId
                        );
                    }

                    this._registerLogFeedListeners();

                    return this._networkDiscoveryWorkFeed.whenInitialized();
                }
                return Promise.resolve(this._networkDiscoveryWorkFeed);
            })
            .then((workFeed) => {
                // this._networkDiscoveryWorkFeed = workFeed;
                if (workFeed) {
                    if (_.get(this._networkDiscoveryWork, "type", "") === "Work") {
                        this.updateDiscoveryLog(undefined, true);
                    }
                }
                return Promise.resolve();
            });
    }

    // Function to get work change feed
    getWorkFeed(refreshFeed = false) {
        return Promise.resolve()
            .then(() => {
                this._workLog = [];

                if (!_.isEmpty(this._networkDiscoveryExecutionEntity)) {
                    // Kill the current WorkFeed if execution entity ID changed
                    return !_.isEmpty(this._WorkFeed) && refreshFeed
                        ? this._shutdownWorkFeed()
                        : Promise.resolve()
                              .then(() => {
                                  if (_.isEmpty(this._WorkFeed) || refreshFeed) {
                                      return this._networkDiscoveryExecutionEntity
                                          .startRelatedWorkFeed()
                                          .whenInitialized()
                                          .then((feed) => {
                                              this._WorkFeed = feed;
                                              this._registerWorkFeedListeners();
                                              return feed;
                                          });
                                  } else {
                                      return this._WorkFeed;
                                  }
                              })
                              .then((feed) => {
                                  if (feed) {
                                      this._WorkFeed = feed;
                                      const workArray = Object.values(_.get(feed, "_cache", {}));
                                      const latestWork = workArray[workArray.length - 1];
                                      this._setWorkAndLogs(latestWork);
                                  }
                                  return Promise.resolve();
                              });
                }
                return Promise.resolve();
            })
            .then(() => {
                return this._setWorkFeed();
            })
            .catch((error) => {
                this._logger.warn({error}, "NetworkDiscoveryDetails::getWorkFeed error");
            });
    }

    _shutdownWorkFeed() {
        return this._WorkFeed.shutdown().then(() => {
            this._unRegisterWorkFeedListeners();
            this._WorkFeed = undefined;
            return Promise.resolve();
        });
    }

    retrieveNetworkDiscoverySettingsFeed() {
        this._networkDiscoverySettingsFeed =
            this._networkDiscoverySettingsEntity.startNetworkDiscoverySettingsFeed(
                this.activeOrgId
            );
        return this._networkDiscoverySettingsFeed.whenInitialized();
    }

    retrieveRelatedNetworkDiscoverySetting() {
        return this._networkDiscoveryPlanFeed.loadRelatedSettings({}).then((entity) => {
            this._defaultNetworkDiscoverySettingEntity = entity;
            return Promise.resolve();
        });
    }

    retrieveDevice(deviceId) {
        if (!deviceId) {
            return Promise.resolve(undefined);
        }
        return this._deviceEntity
            .retrieveDevice(this.activeOrgId, deviceId)
            .then((device) => {
                this._device = device;
                // this._registerFeedListeners();
                return Promise.resolve(this._device);
            })
            .catch((error) => {
                this._logger.warn("Device retriving error", {error});
                return Promise.reject(error);
            });
    }

    setInstanceEditorStateProperty(name, val) {
        _.set(this._instanceEditorState, name, val);
    }

    getInstanceEditorStateProperty(name) {
        return _.get(this._instanceEditorState, name);
    }

    updateTab(name) {
        this._tabCmpnt.setTitle(name);
    }

    closeEditor(id, force) {
        id = id || this._editorTabState.id;
        return super.closeEditor(id, force);
    }

    _switchView(switchTo) {
        this.setActiveView(switchTo);
    }

    _setViewActionText(buttonValue, buttonText) {
        let buttonControl = _.get(
            this._viewContainerElem.nextElementSibling.lastElementChild.querySelectorAll(
                "button-control[value='" + buttonValue + "']"
            ),
            0
        );

        if (buttonControl) {
            buttonControl.innerHTML = buttonText;
        }
    }

    updateDiscoveryLog(value, isEntity = true) {
        if (isEntity) {
            const work = this._networkDiscoveryWork;
            if (work && work.log) {
                this._workLog = work.log === undefined ? [] : work.log;
            }
        } else {
            if (Array.isArray(value)) {
                this._workLog = value;
            } else {
                this._workLog.push(value);
            }
        }

        // Workaround for when this._workLog misses top lines -- Must be refactored
        if (this._workLog && this._workLog[0].lln > 1 && this._networkDiscoveryWorkFeed) {
            let loglines = this._networkDiscoveryWorkFeed.getCache();
            if (!_.isEmpty(loglines)) {
                this._workLog = Object.keys(loglines).map((key) => loglines[key]);
            }
        }

        this.emit("LogUpdated", this._workLog);
    }

    shutdown() {
        let logger = this._logger;

        return super
            .shutdown()
            .then(() => {
                this._deviceConfigFeed = undefined;
                return Promise.resolve();
            })
            .then(() => {
                const promises = [];
                if (!_.isUndefined(this._networkDiscoveryPlanFeed)) {
                    this._unregisterPlanEntityListeners();
                    promises.push(this._networkDiscoveryPlanFeed.shutdown());
                }
                if (!_.isUndefined(this._networkDiscoveryExecutionFeed)) {
                    this._unregisterExecutionFeedListeners();
                    promises.push(this._networkDiscoveryExecutionFeed.shutdown());
                }
                if (
                    !_.isUndefined(this._networkDiscoveryWorkFeed) &&
                    this._networkDiscoveryWorkFeed.shutdown
                ) {
                    this._unregisterLogFeedListeners();
                    promises.push(this._networkDiscoveryWorkFeed.shutdown());
                }
                if (
                    !_.isEmpty(this._networkDiscoverySettingsFeed) &&
                    this._networkDiscoverySettingsFeed.shutdown
                ) {
                    this._unregisterDiscoverySettingsFeedListeners();
                    promises.push(this._networkDiscoverySettingsFeed.shutdown());
                }

                if (!_.isUndefined(this._WorkFeed) && this._WorkFeed.shutdown) {
                    this._unRegisterWorkFeedListeners();
                    promises.push(this._WorkFeed.shutdown());
                }

                return Promise.all(promises);
            })
            .then(() => {
                this._tabCmpnt = undefined;
                this._registeredDetails = undefined;
                this._editorLayout = undefined;
                this._tabId = undefined;
                this._currentDiscoveryWorkId = undefined;
                this._activeOrgId = undefined;
                this._deviceEntity = undefined;
                this._device = undefined;
                this._networkDiscoveryPlan = undefined;
                this._networkDiscoveryPlanFeed = undefined;
                this._networkDiscoveryExecutionFeed = undefined;
                this._networkDiscoveryExecutionEntity = undefined;
                this._device = undefined;
                this._selectedDevice = undefined;
                this._runningStart = undefined;
                this._workLog = undefined;
                this._workEntity = undefined;
                this._networkDiscoveryWorkFeed = undefined;
                this._networkDiscoveryWork = undefined;
                this._networkDiscoverySettingsFeed = undefined;
                this._defaultNetworkDiscoverySettingEntity = undefined;
                this._currentNetworkDiscoverySettingEntity = undefined;
            })
            .catch((err) => {
                logger.warn({error: err}, "DeviceInstanceEditor.shutdown() error");
            });
    }

    _onDirtyStateChanged(newVal) {
        // this._tabCmpnt.setDirty(newVal);
        this._networkDiscoveryPlanFeed.emit("Dirty", newVal);
    }

    _setDirty(state) {
        this._tabCmpnt.setDirty(state);
        // console.log('dirtyState was triggered but ignored');
        //TODO: Case 24590 - perhaps a more elegant solution than simply ignoring dirty state changes.  Dan has suggested we leave it as is for now
        //dirty state really only happens on first launch of network discovery.  Very little need for tracking as multiple users
        //changing this mono-value entity is uneccessary.  Updates are still tracked on form.
        //this._tabCmpnt.setDirty(dirtyState);
    }

    onGridColumnUpdated() {
        this.runQuickConfirmationActionWorkflow(
            {
                message: "Column definitions have been changed. Do you want to refresh the page?",
                title: "Update Confirmation Check",
                confirmDetails: {
                    text: "Yes",
                    type: "text",
                },
            },
            (this.onGridUpdateAction = this.onGridUpdateAction.bind(this))
        );
    }

    onGridUpdateAction() {
        return this.renderer.render();
    }

    _onLogInitialized(pristineProperty) {
        this.updateDiscoveryLog(pristineProperty, false);
        // console.log("Log updated in game editor", this._workLog);
        // this.emit("LogUpdated", this._workLog);
    }

    /**
     * Initializations : START
     */

    async whenGameEditorReady() {
        this._networkDiscoveryPlanEntity = await this.whenNetworkDiscoveryIsReady();

        this._registerPlanEntityListeners();
        return this._networkDiscoveryPlanEntity;
    }

    /**
     * Initializations : END
     */

    /**
     * Entity Methods : START
     */

    whenNetworkDiscoveryIsReady() {
        return this._networkDiscoveryPlan.retrieveNetworkDiscoveryPlan(
            this.activeOrgId,
            this._selectedPlan
        );
    }

    /**
     * Entity Methods : END
     */
}

module.exports = NetworkDiscoveryEditor;

NetworkDiscoveryEditor.$inject = [
    "$teve.logger",
    "$teve.di",
    "$teve.registeredDetails",
    "editorLayout.editorState",
    "editorLayout.editorLayoutMgr",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "editorLayout.editor.tabComponent",
    "$teve.solutionsManager",
    "$teve.io",
    "$teve.entities.NetworkDiscoveryPlan",
    "$teve.entities.Device",
    "$teve.entities.Work",
];

//Optional convenient way to set a tab icon.
NetworkDiscoveryEditor.$editorIcon = "devicemanager.network_discovery";
NetworkDiscoveryEditor.$editorIconType = "base-icon-gl";
